module.exports = __webpack_public_path__ + "fonts/WorkSans-Black.2e3164e.eot";